export const horzRecSlick = (listElements, recList) => {
    if (listElements.length > 0) {
        if ($('#add-to-bag-rec').length > 0 || $('#add-to-registry-rec').length > 0) {
            var next = '<i data-twist="add-to-modal-right" class="fa fa-angle-right slickCustomNext" aria-hidden="true"></i>',
                prev = '<i data-twist="add-to-modal-left" class="fa fa-angle-left slickCustomPrev" aria-hidden="true"></i>',
                slides_desktop = 4,
                slides_mobile = 2;
        } else {
            var next = '<button type="button" class="ada_horzSlickButton slickCustomNext"><span><span class="sr-only">Next</span><i class="slickCustomNext" aria-hidden="true"><svg height="32px" width="32px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25.39 48.77"><title>arrow-right</title><g data-name="Layer 2"><g data-name="Layer 1"><path d="M1,48.77a1,1,0,0,1-.71-1.71L23,24.39.29,1.71A1,1,0,0,1,1.71.29L25.09,23.68a1,1,0,0,1,0,1.41L1.71,48.48A1,1,0,0,1,1,48.77Z"/></g></g></svg></i></span></button>',
                prev = '<button type="button" class="ada_horzSlickButton slickCustomPrev"><span><span class="sr-only">Previous</span><i class="slickCustomPrev" aria-hidden="true"><svg height="32px" width="32px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25.39 48.77"><title>arrow-left</title><g data-name="Layer 2"><g data-name="Layer 1"><path d="M24.39,48.77a1,1,0,0,1-.71-.29L.29,25.09a1,1,0,0,1,0-1.41L23.68.29a1,1,0,0,1,1.41,1.41L2.41,24.39,25.09,47.07a1,1,0,0,1-.71,1.71Z"/></g></g></svg></i></span></button>',
                slides_desktop = 6,
                slides_mobile = 3;
        }
        recList.not('.slick-initialized').slick({
            draggable: false,
            infinite: false,
            nextArrow: next,
            prevArrow: prev,
            slidesToShow: slides_desktop,
            slidesToScroll: 1,
            responsive: [{
                breakpoint: 1025,
                settings: {
                    arrows: false,
                    slidesToShow: 4,
                    swipe: true,
                    swipeToSlide: true
                }
            }, {
                breakpoint: 768,
                settings: {
                    arrows: false,
                    slidesToShow: slides_mobile,
                    swipe: true,
                    swipeToSlide: true
                }
            }]
        });
    }
}
